module.exports = __webpack_public_path__ + "img/ic-engajamento.a6d84428.png";